import { FC, useMemo } from "react"
import { DownloadType } from "../../../../../../Hooks/useJobListDownload"
import { APIJobsPerStatusModel } from "../../../../../../Models/API/APIJobsPerStatusModel"
import {
    APIJobModel,
    JobDialog,
    JobType
} from "../../../../../../Models/API/JobModel"
import { DownloadTypeModal } from "../../../Common/Modals/DownloadTypeModal/DownloadTypeModal"
import { CancelConfirmModal } from "./CancelConfirmModal"
import { DeleteModal } from "./DeleteModal"
import { EnqueueModal } from "./EnqueueModel"
import { RelabelConfirmModal } from "./RelabelConfirmModal"

interface JobBaseProps {
    job?: APIJobModel
    dialog: JobDialog | undefined
    downloadType?: DownloadType
    isDownloading?: boolean
    allowResponseDataDownload?: boolean
    handleRelabel?: () => Promise<void>
    handleCancel?: () => Promise<void>
    handleDelete?: () => Promise<void>
    handleEnqueue?: () => Promise<void>
    handleDownload?: () => void
    hideDialog: () => void
    handleDownloadType?: (type: DownloadType) => void
}

export const JobBase: FC<JobBaseProps> = ({
    children,
    dialog,
    job,
    downloadType,
    isDownloading,
    allowResponseDataDownload,
    handleRelabel,
    handleCancel,
    handleDelete,
    handleEnqueue,
    hideDialog,
    handleDownload,
    handleDownloadType
}) => {
    const isLabelByCollaborator = job?.jobType === JobType.COLLABORATOR
    const jobsByStatus = useMemo(
        () =>
            job !== undefined
                ? {
                      ...APIJobsPerStatusModel.zeros(),
                      [job.status]: 1
                  }
                : undefined,
        [job]
    )

    return (
        <>
            {children}
            {handleRelabel !== undefined && dialog === "relabel" ? (
                <RelabelConfirmModal
                    total={1}
                    onYes={handleRelabel}
                    onNo={hideDialog}
                    jobsByStatus={jobsByStatus}
                    isLabelByCollaborator={isLabelByCollaborator}
                />
            ) : handleCancel !== undefined && dialog === "cancel" ? (
                <CancelConfirmModal
                    total={1}
                    onYes={handleCancel}
                    onNo={hideDialog}
                    jobsByStatus={jobsByStatus}
                    isLabelByCollaborator={isLabelByCollaborator}
                />
            ) : handleDelete !== undefined && dialog === "delete" ? (
                <DeleteModal total={1} onYes={handleDelete} onNo={hideDialog} />
            ) : handleEnqueue !== undefined && dialog === "enqueue" ? (
                <EnqueueModal
                    onNo={hideDialog}
                    onYes={handleEnqueue}
                    total={1}
                    jobsByStatus={jobsByStatus}
                    isLabelByCollaborator={isLabelByCollaborator}
                />
            ) : null}
            {handleDownloadType !== undefined &&
            downloadType !== undefined &&
            dialog === "download" ? (
                <DownloadTypeModal
                    name={{ singular: "data point", plural: "data points" }}
                    itemCount={1}
                    onClose={hideDialog}
                    onConfirm={isDownloading ? undefined : handleDownload}
                    onSetType={handleDownloadType}
                    hasFlatten={false}
                    type={downloadType}
                    willDownload={true}
                    allowCsvDownload={false}
                    allowResponseDataDownload={allowResponseDataDownload}
                />
            ) : null}
        </>
    )
}
